<h1>Reseteo de MAC Address</h1>
<div class="mat-elevation-z4 divmarco">
  <form [formGroup]="resetearMacForm" (ngSubmit)="onSubmit()">
    <h1>Datos de Nueva MAC</h1>
    <hr>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Máximo 20 caracteres" appearance="outline" class="input-width-275"
          floatLabel="always">
          <mat-label>Usuario:</mat-label>
          <input matInput formControlName="nombreUsuario" name="nombreUsuario" #inputName maxlength="20"
            placeholder="Ingrese el usuario" autocomplete="off" required>
          <mat-icon matSuffix>person</mat-icon>
          <mat-hint align="end">{{inputName.value.length || 0}}/20</mat-hint>
          <mat-error *ngIf="resetearMacForm.controls['nombreUsuario'].hasError('required')">Usuario es requerido.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Máximo 20 caracteres" appearance="outline" class="input-width-275"
          floatLabel="always">
          <mat-label>MAC Address:</mat-label>
          <input matInput formControlName="nuevaMac" name="nuevaMac" #inputMac maxlength="20"
            placeholder="Ingrese la MAC" autocomplete="off" required>
          <mat-icon matSuffix>desktop_windows</mat-icon>
          <mat-hint align="end">{{inputMac.value.length || 0}}/20</mat-hint>
          <mat-error *ngIf="resetearMacForm.controls['nuevaMac'].hasError('required')">MAC es requerida.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="divconten">
      <p style="font-weight: bold;">(*) Estos campos son obligatorios.</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
      class="divconten">
      <div fxLayout="column">
        <button mat-raised-button (click)="navigateMenu('home');" color="warn" type="button"
          class="align-center-middle">
          <span class="text-icon-space">Regresar a Home</span>
          <mat-icon>home</mat-icon>
        </button>
      </div>
      <div fxLayout="column">
        <button mat-raised-button color="primary" type="submit" class="align-center-middle">
          <span class="text-icon-space">Asignar MAC</span>
          <mat-icon>cloud_upload</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>